import { Grid } from '@mui/material';
import { ReactNode } from 'react';

export const EventItemColumn = ({ children }: { children: ReactNode }) => {
  return (
    <Grid item sx={{ maxWidth: 225 }} zeroMinWidth>
      {children}
    </Grid>
  );
};
